import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})

export class AppComponent {

  title = 'app';

  public thisRoute: string = "undefined";

  public constructor(private router: Router) {
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        //        monitoringService.logPageView("IWS Automation SPA", event.url);
        this.thisRoute = event.url;
      }
    });
  }
}
